import FormSubmitButton from './form-submit-button';
import './form-submit-button.scss';

export default FormSubmitButton;
